export enum ArgumentsImageRatioEnum {
  R1_1 = 'R1_1',
  R4_3 = 'R4_3',
  R16_9 = 'R16_9',
  R9_16 = 'R9_16',
  R3_2 = 'R3_2'
}
